import './AddContentNode.scss';

import React, { useCallback } from 'react';
import BaseNode, { FlowNodeMenuItem } from 'components/FlowBuilder/FlowNodes/BaseNode/BaseNode';
import IconPlus from 'pages/FlowBuilder/assets/icons/IconPlus';
import { useFlowBuilderContext } from 'pages/FlowBuilder/context/flow-builder.context';

const MAIN_CLASS = 'add-content-node';
const CLASSES = {
  LABEL: `${MAIN_CLASS}__label`,
  LABEL_BUTTON: `${MAIN_CLASS}__label__button`,
  ICON_PLUS: `${MAIN_CLASS}__icon-plus`,
  ICON_PLUS_CONTAINER: `${MAIN_CLASS}__icon-plus-container`,
};

type AddContentNodeProps = {
  data: { stepIndex: number };
};

function AddContentNode(props: AddContentNodeProps) {
  const {
    data: { stepIndex },
  } = props;

  const menuItems: FlowNodeMenuItem[] = [];
  const flowBuilderContext = useFlowBuilderContext();
  const handleAddContent = useCallback(() => {
    flowBuilderContext.sidePanels.content.setStepIndex(stepIndex);
    flowBuilderContext.sidePanels.content.setContentContext((prev) => {
      return {
        ...prev,
        headerInfo: {
          ...prev.headerInfo,
          goBackTitle: 'Select/Create a content',
          goBackSubTitle: 'From Flow Builder',
        },
        isOpen: true,
      };
    });
  }, [flowBuilderContext.sidePanels.content, stepIndex]);

  return (
    <BaseNode Icon={IconPlus} menuItems={menuItems} className={MAIN_CLASS}>
      <div className={CLASSES.LABEL}>
        <button className={CLASSES.LABEL_BUTTON} aria-label="Add content" onClick={handleAddContent}>
          <span>+</span>
          Add content(s)
        </button>
      </div>
    </BaseNode>
  );
}

export default AddContentNode;
